import React, { useState, useEffect, useRef } from 'react';
import './CheckoutModal.css';

// Estados do modal: 'aguardando' | 'confirmado' | 'expirado'

function CheckoutModal({ plano, onClose, onConfirmado }) {
    const [fase, setFase] = useState('aguardando'); // aguardando -> confirmado | expirado
    const [segundosRestantes, setSegundosRestantes] = useState(30 * 60); // 30 minutos PIX
    const intervalPolling = useRef(null);
    const intervalTimer = useRef(null);

    const planoInfo = {
        motorista: { titulo: 'Painel de Motorista', emoji: '🚛', cor: '#22c55e' },
        anuncio_avulso: { titulo: 'Anúncio Avulso', emoji: '🐄', cor: '#f59e0b' },
        anuncios_ilimitados: { titulo: 'Produtor PRO', emoji: '⭐', cor: '#a855f7' },
    };
    const info = planoInfo[plano] || { titulo: 'Plano', emoji: '✅', cor: '#22c55e' };

    const formatarTempo = (secs) => {
        const m = Math.floor(secs / 60).toString().padStart(2, '0');
        const s = (secs % 60).toString().padStart(2, '0');
        return `${m}:${s}`;
    };

    useEffect(() => {
        // Polling a cada 3 segundos
        intervalPolling.current = setInterval(async () => {
            try {
                const token = localStorage.getItem('token');
                const resp = await fetch(`${import.meta.env.VITE_API_URL || 'http://localhost:3001'}/api/pagamentos/status`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                const data = await resp.json();
                if (data.confirmado) {
                    setFase('confirmado');
                    clearInterval(intervalPolling.current);
                    clearInterval(intervalTimer.current);
                    // Aguardar 3s e deixar o pai saber
                    setTimeout(() => {
                        if (onConfirmado) onConfirmado(data);
                    }, 3000);
                }
            } catch (e) {
                // silencioso
            }
        }, 3000);

        // Countdown
        intervalTimer.current = setInterval(() => {
            setSegundosRestantes(prev => {
                if (prev <= 1) {
                    clearInterval(intervalTimer.current);
                    clearInterval(intervalPolling.current);
                    setFase('expirado');
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => {
            clearInterval(intervalPolling.current);
            clearInterval(intervalTimer.current);
        };
    }, []);

    return (
        <div className="checkout-overlay">
            <div className="checkout-modal">

                {/* FASE: AGUARDANDO */}
                {fase === 'aguardando' && (
                    <>
                        <div className="checkout-icone" style={{ color: info.cor }}>
                            {info.emoji}
                        </div>
                        <h2 className="checkout-titulo">Aguardando Pagamento</h2>
                        <p className="checkout-subtitulo">
                            Uma nova aba foi aberta com o link de pagamento do <strong>Mercado Pago</strong>.
                            Escaneie o QR Code e pague com PIX.
                        </p>

                        <div className="checkout-status-box">
                            <div className="checkout-pulsing-dot"></div>
                            <span>Aguardando confirmação do banco...</span>
                        </div>

                        <div className="checkout-timer">
                            <span className="timer-label">⏱ Expira em</span>
                            <span className="timer-value">{formatarTempo(segundosRestantes)}</span>
                        </div>

                        <div className="checkout-passos">
                            <div className="passo">
                                <div className="passo-num">1</div>
                                <span>Abra o app do seu banco</span>
                            </div>
                            <div className="passo">
                                <div className="passo-num">2</div>
                                <span>Escaneie o QR Code PIX</span>
                            </div>
                            <div className="passo">
                                <div className="passo-num">3</div>
                                <span>Esta tela atualiza automaticamente</span>
                            </div>
                        </div>

                        <button className="btn-checkout-cancelar" onClick={onClose}>
                            Cancelar
                        </button>
                    </>
                )}

                {/* FASE: CONFIRMADO */}
                {fase === 'confirmado' && (
                    <div className="checkout-sucesso">
                        <div className="sucesso-check">
                            <svg viewBox="0 0 52 52" className="checkmark-svg">
                                <circle className="checkmark-circle" cx="26" cy="26" r="25" fill="none"/>
                                <path className="checkmark-tick" fill="none" d="M14 27 L22 35 L38 17"/>
                            </svg>
                        </div>
                        <h2>Pagamento Confirmado! {info.emoji}</h2>
                        <p>
                            Seu acesso ao <strong>{info.titulo}</strong> foi ativado com sucesso.
                        </p>
                        <p className="sucesso-sub">Redirecionando em instantes...</p>
                    </div>
                )}

                {/* FASE: EXPIRADO */}
                {fase === 'expirado' && (
                    <div className="checkout-expirado">
                        <div className="expirado-icone">⌛</div>
                        <h2>PIX Expirado</h2>
                        <p>O tempo para pagamento esgotou. Você pode tentar novamente.</p>
                        <button className="btn-plano btn-avulso" onClick={onClose}>
                            Tentar Novamente
                        </button>
                    </div>
                )}

            </div>
        </div>
    );
}

export default CheckoutModal;
